import { render, staticRenderFns } from "./TaskInfo.vue?vue&type=template&id=d6ee3460&scoped=true&"
import script from "./TaskInfo.vue?vue&type=script&lang=ts&"
export * from "./TaskInfo.vue?vue&type=script&lang=ts&"
import style0 from "./TaskInfo.vue?vue&type=style&index=0&id=d6ee3460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ee3460",
  null
  
)

export default component.exports